/**
 * Constants for file validation
 */
// Must match server constants '@server/modules/client-matter/common/constants'
// TODO SER-436: Update usage of shared constants between client and server
export const BYTES_IN_MB = 1024 * 1024;
export const MAX_FILE_SIZE_MB = 50;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * BYTES_IN_MB;
export const MAX_INT_32 = 2147483647;
export const MICROSOFT_INTEGRATION_CLIENT_ID = 'ed137691-754e-407d-b61d-90a87fb1e191'; // safe to be exposed to client

/**
 * Constants for folder paths
 */
export const ROOT_FOLDER_PATH = '/root';
